"use client";

import { motion, useReducedMotion } from "framer-motion";
import { MapPin, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
export default function ServiceAreas() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="dublin4serviceareas" data-nav="light" className="bg-muted/50 text-foreground py-16 md:py-24 px-4 sm:px-6 lg:px-8 border-y border-border/60">
      <div className="max-w-5xl mx-auto text-center">
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1
      } : {
        opacity: 0,
        y: -10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }}>
          <Badge variant="outline" className="mb-4 rounded-full px-3 py-1 border-primary/30 text-primary bg-primary/5">
            <MapPin className="size-3.5 mr-1" />
            <span>Local Dublin Coverage</span>
          </Badge>

          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight font-default text-foreground">
            Serving All Dublin Areas, with Local Coverage Throughout Dublin 4
          </h2>

          <p className="mt-4 text-base sm:text-lg text-muted-foreground max-w-2xl mx-auto font-default leading-relaxed">
            We provide plumbing, boiler and heat pump services throughout Dublin city and county, with local coverage across Dublin 4, including Ringsend, Sandymount, Ballsbridge, Donnybrook and Irishtown. Contact us with your Eircode to confirm availability.
          </p>

          <div className="mt-8 flex justify-center">
            <Button asChild size="lg" className="rounded-lg shadow-md font-semibold px-6">
              <Link to="/PlumberDublin4Page">
                <span>View Areas Covered</span>
                <ArrowRight className="size-4 ml-1" />
              </Link>
            </Button>
          </div>
        </motion.div>
      </div>
    </section>;
}